import { Alert, AlertDescription, AlertTitle } from '../ui/alert';
import { AlertTriangle } from 'lucide-react';
import { computeClinicalAlerts } from '../../lib/clinicalIntakeSchema';

export default function ClinicalAlertsBanner({ intake }) {
  const alerts = computeClinicalAlerts(intake);
  if (!alerts.length) return null;

  return (
    <Alert variant="destructive" className="border-amber-500/50 bg-amber-50 text-amber-950">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Alertas clínicas</AlertTitle>
      <AlertDescription>
        <ul className="list-disc pl-4 mt-1 space-y-0.5">
          {alerts.map((a) => (
            <li key={a.id}>{a.label}</li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );
}
